import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  return <div className="w-full bg-brand-crimson text-white py-3 px-4 sticky top-0 z-50 shadow-lg border-b border-red-900" data-id="element-227">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-center sm:justify-between text-sm sm:text-base font-medium text-center sm:text-left gap-2 sm:gap-4" data-id="element-228">
        <p className="flex-1" data-id="element-229">
          <span className="font-bold uppercase tracking-wider" data-id="element-230">Atención:</span>{' '}
          Oferta Especial disponible por tiempo limitado. Descuento del 75%
          activo hoy.
        </p>
        <CountdownTimer data-id="element-231" />
      </div>
    </div>;
}